module.exports = __webpack_public_path__ + "e2b6ac8cb76b8ce5b1f7cbcdd055ad3f.svg";